import SettingsView from "../../components/settings/SettingsView";

export function SettingsPage({
  currentUser,
  integrationDiagnostics,
  onContextChange,
  onRefreshIntegrationDiagnostics,
  roleScope,
}) {
  return (
    <SettingsView
      currentUser={currentUser}
      integrationDiagnostics={integrationDiagnostics}
      onContextChange={onContextChange}
      onRefreshIntegrationDiagnostics={onRefreshIntegrationDiagnostics}
      roleScope={roleScope}
    />
  );
}

export default SettingsPage;
